/*global s9e*/

// import twemoji from 'twemoji';

import { override } from 'flarum/extend';
import Post from 'flarum/models/Post';



// const options = {
//   attributes: () => ({
//     loading: 'lazy',
//   }),
// };


export default function render() {
  override(Post.prototype, 'contentHtml', function (original) {
    const contentHtml = original();
    const parser = new DOMParser();
    const d = parser.parseFromString(contentHtml, "text/html");

    const allowedHosts = (window.location.host + ', ' + app.forum.data.attributes['censorbot.hostException']);
    const blockLinks = app.forum.data.attributes['censorbot.blockOffsiteLinks'];
    const replacementText = app.forum.data.attributes['censorbot.offsiteLinkReplacementText'];
    var hostArray = allowedHosts.replace(/\s/g, '').split(',');



    const isExternalLink = (url) => {
      const tmp = document.createElement('a');
      if(!url.includes('mailto:')){
        tmp.href = 'http://' + url;
      } else {
        tmp.href = url;
      }
      var notAllowed = true;
      var clean = tmp.host.replace('www.', '');
      for (const host of hostArray) {
        if (host.includes(clean)) {
          notAllowed = false;
        }
      }
      return notAllowed;
    };

    if (blockLinks == 1) {
      // Find links from a tags
      var link = d.getElementsByTagName('a');
      for (const l of link) {
        var email = l.href.replace('mailto:' , '')
        // console.log('host:',email)
        if (isExternalLink(l.host) || isExternalLink(email)) {
          l.innerHTML = replacementText
          l.href = '';
          l.classList.add('disable-link');
        }
      }


      var text = d.getElementsByTagName('p');
      for (let i = 0; i < text.length; i++) {
        var _this = text[i];

        // Find links from text
        var sites = _this.innerHTML.match(/(www\.)?[A-Za-z0-9]+-?[a-z0-9]+\.(org|com|net)(\.[a-z]+)?/g);
        if (sites != null) {
          for (const site of sites) {
            if (isExternalLink(site)) {
              var str = _this.innerHTML;
              _this.innerHTML = str.replace(site, `<a class='disable-link'>${replacementText}</a>`);
              var newE = parser.parseFromString(_this.innerHTML, "text/html");
              _this.innerHTML = newE.body.innerHTML
            }
          }
        }

      }
    }


    if (this.oldContentHtml !== contentHtml) {
      this.emojifiedContentHtml = d.documentElement.innerHTML;
      this.oldContentHtml = d.documentElement.innerHTML;
    }

    return this.emojifiedContentHtml;
  });

  override(s9e.TextFormatter, 'preview', (original, text, element) => {
    original(text, element);

    // twemoji.parse(element, options);
  });
}